import { render, staticRenderFns } from "./AgentBalance.vue?vue&type=template&id=27bc739a&scoped=true"
import script from "./AgentBalance.vue?vue&type=script&lang=js"
export * from "./AgentBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc739a",
  null
  
)

export default component.exports